export default function componentWillReceiveProps(nextProps) {
  if (!this.props.getSelectedWeldIds && typeof nextProps.getSelectedWeldIds === 'function') {
    let weld_ids = this.state.selectedIndexes.map(idx => this.state.welds[idx].id && Number(this.state.welds[idx].id)).filter(Boolean)
    nextProps.getSelectedWeldIds(weld_ids)
  }

  if (this.state.gridUpdatedRow || this.state.LogModalWeldIdx !== null) {
    return
  }

  if (!nextProps.data.loading && nextProps.data.welds) {
    let newWelds = this.prepareWelds(nextProps.data.welds.list)
    // Zachowaj lokalne zmiany statusu 'removed'
    newWelds = newWelds.map(newWeld => {
      let existingWeld = this.state.welds.find(w => w.id === newWeld.id)
      if (existingWeld && existingWeld.status === 'removed') {
        return { ...newWeld, status: 'removed' }
      }
      return newWeld
    })
    this.setState({
      welds: newWelds,
      metadata: nextProps.data.welds.metadata
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/Welds/helpers/WeldsDataGridComponentWillReceiveProps.js